import { render, staticRenderFns } from "./HandleExDia.vue?vue&type=template&id=e6c5b082&"
import script from "./HandleExDia.vue?vue&type=script&lang=js&"
export * from "./HandleExDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports